// ✅ src/components/screens/AboutSiteScreen.js (EXPANDED)
// ✅ More detailed explanation + clearer sections + who it's for + key benefits + FAQ mini

import React from "react";

export default function AboutSiteScreen({ goBack }) {
  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button
          onClick={goBack}
          style={{
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid #e5e5e5",
            background: "#fff",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          ← Back
        </button>

        <h1 style={{ margin: 0, fontSize: 26 }}>What’s this site about?</h1>
      </div>

      <div
        style={{
          marginTop: 14,
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 16,
          padding: 16,
          lineHeight: 1.6,
        }}
      >
        <p style={{ marginTop: 0, fontSize: 16 }}>
          <b>YourStore</b> is a simple platform that helps anyone create their own{" "}
          <b>online shop</b> in minutes.
          Instead of sending product pictures one-by-one in WhatsApp, Instagram, or
          Telegram, you can upload everything once and share <b>one store link</b>
          (or a QR code) for customers to browse all your items anytime.
        </p>

        <div
          style={{
            marginTop: 12,
            padding: 12,
            borderRadius: 14,
            border: "1px solid #f0f0f0",
            background: "#fafafa",
          }}
        >
          <b>In one sentence:</b> Create your store → upload products → share your
          link → receive orders → get paid directly → deliver.
        </div>

        <h3 style={{ marginTop: 18, marginBottom: 6 }}>Who this is for</h3>
        <ul style={{ marginTop: 0 }}>
          <li>Small business owners and online sellers</li>
          <li>Instagram / TikTok sellers who want a clean shop link</li>
          <li>People who sell clothes, phones, accessories, cosmetics, food, etc.</li>
          <li>Anyone who wants to look more professional online</li>
        </ul>

        <h3 style={{ marginBottom: 6 }}>How it works</h3>
        <ol style={{ marginTop: 0 }}>
          <li>
            <b>Create your store</b> (name, logo/banner, location, description)
          </li>
          <li>
            <b>Add products</b> with prices, photos, sizes/colors, and details
          </li>
          <li>
            <b>Add your payment options</b> (MoMo, bank transfer, cash on pickup)
          </li>
          <li>
            <b>Share your link</b> to customers (or show your QR code)
          </li>
          <li>
            <b>Receive orders</b> and manage them from your seller dashboard
          </li>
          <li>
            <b>Deliver</b> yourself or use any rider/courier you prefer
          </li>
        </ol>

        <h3 style={{ marginBottom: 6 }}>What makes it different</h3>
        <ul style={{ marginTop: 0 }}>
          <li>
            <b>No commissions</b> — you keep <b>100%</b> of your sales
          </li>
          <li>
            <b>Your payment methods</b> — customers pay you directly (MoMo/Bank/Cash)
          </li>
          <li>
            <b>One link for everything</b> — stop sending products one-by-one
          </li>
          <li>
            <b>Order management</b> — track, confirm, and fulfill orders easily
          </li>
          <li>
            <b>Looks professional</b> — your own clean online store front
          </li>
        </ul>

        <h3 style={{ marginBottom: 6 }}>Why people love it</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 10,
            marginTop: 10,
          }}
        >
          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fafafa",
              fontWeight: 600,
            }}
          >
            ✅ Fast setup — create a store in minutes
          </div>
          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fafafa",
              fontWeight: 600,
            }}
          >
            ✅ Share one link — customers see everything
          </div>
          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fafafa",
              fontWeight: 600,
            }}
          >
            ✅ Direct payment — MoMo/Bank/Cash
          </div>
          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fafafa",
              fontWeight: 600,
            }}
          >
            ✅ Manage orders — track and fulfill easily
          </div>
        </div>

        <h3 style={{ marginTop: 18, marginBottom: 6 }}>Mini FAQ</h3>
        <div style={{ display: "grid", gap: 10 }}>
          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fff",
            }}
          >
            <b>Do I need a website or coding?</b>
            <div>No. You just create a store and upload products.</div>
          </div>

          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fff",
            }}
          >
            <b>How do customers pay?</b>
            <div>
              Customers pay using the options you add (MoMo, bank, cash on pickup).
            </div>
          </div>

          <div
            style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid #f0f0f0",
              background: "#fff",
            }}
          >
            <b>Does YourStore deliver for me?</b>
            <div>
              You handle delivery yourself or use any rider/courier you want.
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: 16,
            padding: 12,
            borderRadius: 14,
            border: "1px solid #f0f0f0",
            background: "#fafafa",
          }}
        >
          <b>Tip:</b> When someone asks what you sell, don’t explain—just send your
          store link. They’ll see everything instantly.
        </div>
      </div>
    </div>
  );
}
